import { makeAutoObservable } from "mobx";

class stateFilter {
  constructor() {
    makeAutoObservable(this);
  }

  subscription_companies = true;
  filter_active_client = true;
  filter_active_server = false;

  setLocalStorage = (name, data) => {
    try {
      localStorage.setItem(name, data);
    } catch (e) {
      console.error(e);
    }
  };

  setParameter = (name, value) => {
    this[`${name}`] = value;
  };
}
export default new stateFilter();
